import { useParams } from "react-router";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { OfferTableComponent } from "@/routes/processes/[processId]/qpm/offers/_components/offer-table-component";
import {
  MilestonePage,
  MilestonePageActions,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { CreateOfferDialog } from "@/routes/processes/[processId]/qpm/offers/_components/create-offer-dialog";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { Loader2 } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function OfferIndexRoute() {
  const params = useParams();
  const { processId } = params;

  const {
    data: process,
    error: processDataError,
    isLoading: processDataIsLoading,
  } = useProcessesProcessShowQuery({
    id: processId ?? "",
  });

  if (processDataIsLoading) {
    return <Loader2 className="animate-spin" />;
  }

  if (!processId || !process) {
    return <div>Fehler beim Laden des Vorgangs!</div>;
  }

  if (processDataError) {
    return <RTKQueryErrorAlert error={processDataError} />;
  }

  if (!process.customerId) {
    return <div>{t("Diesem Vorgang ist noch kein Kunde zugeordnet.")}</div>;
  }

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Angebote")}</MilestonePageTitle>
        <MilestonePageActions>
          {process && (
            <CreateOfferDialog
              customerId={process.customerId}
              processId={process.id}
            />
          )}
        </MilestonePageActions>
      </MilestonePageHeader>
      <MilestonePageContent>
        <Card>
          <OfferTableComponent processId={processId!} />
        </Card>
      </MilestonePageContent>
    </MilestonePage>
  );
}
